import { render, staticRenderFns } from "./page6.vue?vue&type=template&id=39a27258&scoped=true&"
import script from "./page6.vue?vue&type=script&lang=ts&"
export * from "./page6.vue?vue&type=script&lang=ts&"
import style0 from "./page6.vue?vue&type=style&index=0&id=39a27258&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a27258",
  null
  
)

export default component.exports